/***
 * 系统配置信息
 *
 * 后台服务地址,用户默认头像等一些配置信息
 */
export const FILE_SERVE_URL = ""//文件存放地址
export const DEFAULT_HEAD_URL = ""//默认头像存放地址
export const GOODLIST_URL = 'http://rapapi.org/mockjsdata/18396/api/discove/goodlist';
export const GOODLIST_head_URL = 'http://img.lapin365.com/productpictures';

export const MAX_DATE = "2050-12-31"//默认最大日期
export const MIN_DATE = "1990"//默认最小日期
export const HEADSHOW = 'false';//日历头部是否显示 “上”“下”按钮  false||true
export const TRIPTYPE = 'month';//日历默认展示月或者周  month  & week
export const MOREORONE = 'one'; //日历事件是否可跨天  more :表示可跨天连续多天  one:表示单一某天 

export const MODEL='test';// test :测试环境     formal: 正式环境x

//webservice 请求地址
export const APP_WEBSERVICE_URL = "https://mm.supwisdom.com/service/appGenReq.do";//"http://172.28.0.17:8080/service/appGenReq.do"
//websocket 请求地址
export const APP_WEBSOCKET_URL = "wss://mm.supwisdom.com/websocket";












//基础路径
export const APP_SERVE_URL = "http://172.28.0.17/";
//本地路径
export const LOCAL_SERVE_URL = "http://localhost:8080/frame2/";
//export const APP_SERVE_URL = "http://10.250.1.20/"//网站后台地址
//export const APP_SERVE_URL = "http://192.168.2.70/"
//export const APP_SERVE_URL = "http://172.28.0.132:8080/frame2/"
//查询个人一卡通余额
export const getPersonBalanceUrl = APP_SERVE_URL+'home/nTrip/monthTripList.action'; 
//查询月行程
export const monthTripListUrl = APP_SERVE_URL+'home/nTrip/monthTripList.action';
//查询周行程
export const weekTripListUrl = APP_SERVE_URL+'home/nTrip/weekTripList.action';
//日程新增更新
export const tripSaveOrUpdateUrl = APP_SERVE_URL+'home/nTrip/saveOrUpdateTrip.action';
//查询日历
export const queryCalendarUrl = APP_SERVE_URL+"home/nTrip/queryCalendars.action";
//删除日历行程	
export const deleteTripUrl = APP_SERVE_URL+"home/nTrip/deleteTrip.action";


	






// WEBPACK FOOTER //
// ./src/providers/config/constants.ts